function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M512 256c0 141-115 256-256 256S0 397 0 256 115 0 256 0s256 115 256 256zm0 0l-255 40h107c16 0 28-13 28-29 0-15-12-28-28-28h-94l-46-114c-6-14-22-21-37-15-14 6-21 22-15 37l50 125c2 9 8 17 16 21 6 3 12 4 19 3zm0 0"
}));